import { tokens } from '../tokens';

type FlexAlign = 'flex-start' | 'flex-end' | 'center' | 'stretch' | 'baseline';
type FlexJustify = 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly';

export const flexRow = (gap?: number, align?: FlexAlign, justify?: FlexJustify) => ({
  display: 'flex' as const,
  flexDirection: 'row' as const,
  ...(gap !== undefined && { gap }),
  ...(align && { alignItems: align }),
  ...(justify && { justifyContent: justify }),
});

export const flexColumn = (gap?: number, align?: FlexAlign, justify?: FlexJustify) => ({
  display: 'flex' as const,
  flexDirection: 'column' as const,
  ...(gap !== undefined && { gap }),
  ...(align && { alignItems: align }),
  ...(justify && { justifyContent: justify }),
});

export const flexCenter = {
  display: 'flex' as const,
  alignItems: 'center' as const,
  justifyContent: 'center' as const,
};

export const gridLayout = (columns: string, gap?: number) => ({
  display: 'grid' as const,
  gridTemplateColumns: columns,
  ...(gap !== undefined && { gap }),
});

/**
 * Standard filter bar layout — horizontal flex with consistent padding.
 * Use for page-level filter bars, toolbar rows.
 */
export const filterBar = {
  display: 'flex' as const,
  alignItems: 'center' as const,
  flexWrap: 'wrap' as const,
  gap: tokens.spacing.sm,
  padding: `${tokens.spacing.ms}px ${tokens.spacing.md}px`,
};

/**
 * Standard modal/drawer footer with right-aligned buttons.
 */
export const modalFooter = {
  display: 'flex' as const,
  justifyContent: 'flex-end' as const,
  gap: tokens.spacing.sm,
  padding: `${tokens.spacing.md}px ${tokens.spacing.lg}px`,
};

/**
 * Standard form container with consistent label/field spacing.
 */
export const formContainer = {
  '& .ant-form-item': {
    marginBottom: tokens.spacing.md,
  },
  '& .ant-form-item-label': {
    textAlign: 'left',
    fontWeight: tokens.fontWeight.semibold,
    lineHeight: '26px',
  },
};
